import { Typography } from '@material-ui/core'

import { getTranslate } from '../../localization'
import { Accommodation, BulkIdCode } from '../../types/accommodation'
import ProviderListEachRow from './ProviderListEachRow'
import useStyles from './styles/providerList.styles'

interface ProviderListProps {
  accommodationList: Accommodation[]
  setAccommodationIdCodes: React.Dispatch<React.SetStateAction<BulkIdCode[]>>
  setAccommodationList: React.Dispatch<React.SetStateAction<Accommodation[]>>
  filteredAccommodationList: Accommodation[]
  setFilteredAccommodationList: React.Dispatch<
    React.SetStateAction<Accommodation[]>
  >
}
const ProviderList: React.FC<ProviderListProps> = ({
  accommodationList,
  setAccommodationIdCodes,
  setAccommodationList,
  filteredAccommodationList,
  setFilteredAccommodationList
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.list}>
        <div className={classes.header}>
          <Typography variant="h4" className={classes.providerName}>
            {getTranslate('Accommodations Names')}
          </Typography>
        </div>
        <div className={classes.body}>
          {filteredAccommodationList.length > 0 &&
            filteredAccommodationList.map((acc, index) => (
              <ProviderListEachRow
                key={index}
                AccommodationItem={acc}
                setAccommodationIdCodes={setAccommodationIdCodes}
                index={index}
                setFilteredAccommodationList={setFilteredAccommodationList}
                filteredAccommodationList={filteredAccommodationList}
                setAccommodationList={setAccommodationList}
                accommodationList={accommodationList}
              />
            ))}
        </div>
      </div>
    </div>
  )
}

export default ProviderList
